/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dropdown': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17.71 10.45l-5 4.3a1.11 1.11 0 0 1-1.4 0l-5-4.3A.84.84 0 0 1 7 9h10a.84.84 0 0 1 .71 1.45z" _fill="#dae4e9"/>'
  }
})
